import React from "react";

import { i18n } from "../../../translate/i18n";

function FilterChip({ active, onClick, children }) {
	return (
		<button
			type="button"
			className={`shrink-0 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
				active
					? "bg-primary text-white"
					: "bg-default-100 text-default-600 hover:bg-default-200 dark:bg-default-800 dark:text-default-400 dark:hover:bg-default-700"
			}`}
			onClick={onClick}
		>
			{children}
		</button>
	);
}

function FilterOption({ active, onClick, children }) {
	return (
		<button
			type="button"
			className={`w-full rounded-lg px-3 py-2 text-left text-xs font-semibold transition-colors ${
				active
					? "bg-primary/15 text-primary"
					: "text-default-600 hover:bg-default-100 dark:text-default-400 dark:hover:bg-default-800"
			}`}
			onClick={onClick}
		>
			{children}
		</button>
	);
}

export default function CommentFeedFilterRail({
	channel,
	status,
	search,
	onChannelChange,
	onStatusChange,
	onSearchChange,
}) {
	const channels = [
		{ id: "all", label: i18n.t("socialComments.filters.all") },
		{ id: "facebook", label: i18n.t("socialComments.filters.facebook") },
		{ id: "instagram", label: i18n.t("socialComments.filters.instagram") },
		{ id: "tiktok", label: i18n.t("socialComments.filters.tiktok") },
		{ id: "mercadolivre", label: i18n.t("socialComments.filters.mercadolivre") },
	];

	const statuses = [
		{ id: "all", label: i18n.t("socialComments.filters.statusAll") },
		{ id: "open", label: i18n.t("socialComments.status.open") },
		{ id: "replied", label: i18n.t("socialComments.status.replied") },
	];

	return (
		<aside className="w-full shrink-0 border-b border-default-200 bg-default-50/50 dark:border-default-700 dark:bg-default-900/20 lg:flex lg:h-full lg:w-64 lg:flex-col lg:border-b-0 lg:border-e">
			{/* Mobile: busca + chips horizontais (não ocupa a tela toda) */}
			<div className="flex flex-col gap-3 p-3 lg:hidden">
				<input
					type="search"
					className="form-input w-full text-sm"
					placeholder={i18n.t("socialComments.searchPlaceholder")}
					value={search}
					onChange={(e) => onSearchChange(e.target.value)}
				/>
				<div className="flex gap-2 overflow-x-auto pb-0.5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
					{channels.map((item) => (
						<FilterChip
							key={item.id}
							active={channel === item.id}
							onClick={() => onChannelChange(item.id)}
						>
							{item.label}
						</FilterChip>
					))}
				</div>
				<div className="flex gap-2 overflow-x-auto pb-0.5 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
					{statuses.map((item) => (
						<FilterChip
							key={`st-${item.id}`}
							active={status === item.id}
							onClick={() => onStatusChange(item.id)}
						>
							{item.label}
						</FilterChip>
					))}
				</div>
			</div>

			{/* Desktop: rail lateral */}
			<div className="hidden h-full flex-col gap-5 p-4 lg:flex">
				<div>
					<input
						type="search"
						className="form-input w-full text-sm"
						placeholder={i18n.t("socialComments.searchPlaceholder")}
						value={search}
						onChange={(e) => onSearchChange(e.target.value)}
					/>
				</div>

				<div>
					<p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-default-500">
						{i18n.t("socialComments.filters.channel")}
					</p>
					<div className="flex flex-col gap-1">
						{channels.map((item) => (
							<FilterOption
								key={item.id}
								active={channel === item.id}
								onClick={() => onChannelChange(item.id)}
							>
								{item.label}
							</FilterOption>
						))}
					</div>
				</div>

				<div>
					<p className="mb-2 text-[11px] font-semibold uppercase tracking-wide text-default-500">
						{i18n.t("socialComments.filters.status")}
					</p>
					<div className="flex flex-col gap-1">
						{statuses.map((item) => (
							<FilterOption
								key={item.id}
								active={status === item.id}
								onClick={() => onStatusChange(item.id)}
							>
								{item.label}
							</FilterOption>
						))}
					</div>
				</div>
			</div>
		</aside>
	);
}
